import { Checkbox } from 'uikit';

import { useCallback, useMemo } from 'react';

import type { ICheckedObjectsCellRendererProps } from '../../WorkOrder/AddWorkOrderUer/helpersAndTypes';

export const CheckboxGridRenderer = (props: ICheckedObjectsCellRendererProps) => {
    const { checkedObjects, data, onChangeCheckedObjects } = props;

    const onChangeCreator = useCallback(
        (id: number) =>
            ({ checked }: { checked: boolean }) => {
                onChangeCheckedObjects({
                    [id]: checked,
                });
            },
        [onChangeCheckedObjects],
    );

    const isChecked = useMemo(
        () => Boolean(checkedObjects[data.id] !== 'intermediate' && checkedObjects[data.id]),
        [checkedObjects, data.id],
    );
    const isIntermediate = useMemo(() => checkedObjects[data.id] === 'intermediate', [checkedObjects, data.id]);

    return <Checkbox onChange={onChangeCreator(data.id)} checked={isChecked} intermediate={isIntermediate} />;
};

CheckboxGridRenderer.displayName = 'CheckboxGridRenderer';
